import { render, staticRenderFns } from "./resultsQuery.vue?vue&type=template&id=472d67a7&scoped=true"
import script from "./resultsQuery.vue?vue&type=script&lang=js"
export * from "./resultsQuery.vue?vue&type=script&lang=js"
import style0 from "./resultsQuery.vue?vue&type=style&index=0&id=472d67a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d67a7",
  null
  
)

export default component.exports